<div class="top-bar">
  <button
    pButton
    type="button"
    class="alert-icon-btn"
    [ngClass]="(borderClass$ | async)!"
    icon="pi pi-exclamation-triangle"
    (click)="panel.toggle($event)"
    aria-label="Open Pokémon issues"
  ></button>
  <input
    type="text"
    class="alert-label-input p-inputtext"
    placeholder="Pokémon query"
    aria-label="Pokémon query"
  />

  <div class="search-input">
    <input
      type="text"
      class="top-select-input p-inputtext"
      placeholder="Trainer / Pokémon"
      aria-label="Trainer / Pokémon search"
    />
    <i class="pi pi-search search-icon" aria-hidden="true"></i>
  </div>

  <button
    pButton
    type="button"
    label="Catch Pokémon"
    class="top-calc-btn p-button-sm p-button-rounded"
  ></button>

  <p-popover
    #panel
    [dismissable]="true"
    styleClass="pok-overlay"
  >
  <ng-container *ngIf="(messages$ | async) as messages">
    <div class="error-panel pok-panel" *ngIf="messages.length; else allGood" (mouseleave)="onPanelMouseLeave()" [ngClass]="(panelClass$ | async)!">
      <div class="error-header pok-header">
        <i [ngClass]="(headerIconClass$ | async)!"></i>
        <span class="title">
          Issues ({{ (counts$ | async)?.total ?? 0 }}) with your Pokémon query
        </span>
        <a
          class="clear"
          (click)="onClearAll($event)"
          pTooltip="Clear all (Ctrl+k)"
          tooltipPosition="right"
          aria-label="Clear all (Ctrl+k)"
        >
          Clear all
        </a>
      </div>

      <div class="error-list">
        <div
          *ngFor="let msg of messages; let i = index"
          class="error-item"
          [ngClass]="{
            main: i === 0,
            'msg-error': msg.level === 'error',
            'msg-warning': msg.level === 'warning',
            'msg-info': msg.level === 'info',
            fading: isFading(msg.id)
          }"
          (mouseenter)="onItemMouseEnter(msg.id)"
          (mouseleave)="onItemMouseLeave(msg.id)"
          (click)="onItemClick(msg.id)"
        >
          <i
            [class]="'error-bullet pi ' + (msg.level === 'error' ? 'pi-exclamation-circle' : (msg.level === 'warning' ? 'pi-exclamation-triangle' : 'pi-info-circle'))"
          ></i>
          <div class="msg-text">{{ msg.text }}</div>
          <button
            pButton
            type="button"
            icon="pi pi-times"
            class="close-btn p-button-rounded p-button-text"
            (click)="onRemove(msg.id)"
            aria-label="Dismiss message"
            pTooltip="Dismiss (Esc)"
            tooltipPosition="right"
          ></button>
        </div>
      </div>
    </div>

    <ng-template #allGood>
      <div class="error-panel ok pok-panel">
        <div class="error-header pok-header">
          <i class="pi pi-check-circle"></i>
          <span class="title">All good — no issues with your Pokémon query</span>
        </div>
      </div>
    </ng-template>
  </ng-container>
</p-popover>
